import { Typography } from '@mui/material'
import { AuctionStatus } from '@xyo-network/sdk-xyoworld-js'
import { useContext } from 'react'

import { MinterAuctionContext } from '../../Contexts'
import { colorFromAuctionStatus } from '../../lib'
import { Property } from '../Property'

const StatusProperty: React.FC = () => {
  const { auction } = useContext(MinterAuctionContext)
  if (auction) {
    const status = auction.status()
    const color = colorFromAuctionStatus(status)

    const statusMessage = (() => {
      switch (status) {
        case AuctionStatus.Upcoming:
          return 'Not started'
        case AuctionStatus.Live:
          return 'Live'
        case AuctionStatus.Dutch:
          return 'Dutch'
        case AuctionStatus.Completed:
          return 'Completed'
        case AuctionStatus.Minted:
          return 'Minted'
        default:
          return 'Unknown'
      }
    })()

    return (
      <Property title="Status" value={statusMessage}>
        <Typography style={{ color }} variant="caption">
          {statusMessage}
        </Typography>
      </Property>
    )
  }
  return null
}

export default StatusProperty
